export default function videoWidget() {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;
  const widgetHTML = $(`#${widgetName}`);

  widgetHTML.append('<iframe></iframe>');
  widgetHTML.wrap('<div id="videoSection"></div>');

  widgetHTML.videoWidget({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    detectIpad: IPADDETECTED,
    // options
    multiVideo: false,
    showOnMobile: true,
    maxVideos: 1,
    autoPlayVideo: false,
    loopVideo: true, // Autoplay must be enabled
    showControls: true,

    videoWidgetLoaded: function (data) {
      if (data.Slides.length < 1) $('#videoSection').remove();
    },
  });
}
